import { createSelector } from '@ngrx/store';
import { getGlobalHomeFeatureStore } from '../index';

const getPeopleToFollowFeatureState = createSelector(
  getGlobalHomeFeatureStore,
  state => state.peopleToFollow
);

export const getPeopleToFollowState = createSelector(
  getPeopleToFollowFeatureState,
  state => state.peopleState
);
export const getPeopleToFollowLoading = createSelector(
  getPeopleToFollowFeatureState,
  state => state.loading
);
export const getPeopleToFollowError = createSelector(
  getPeopleToFollowFeatureState,
  state => state.error
);
